import { useEffect } from 'react';

/**
 * Den gamle plattformsiden er erstattet (30/9): / er forsiden (public/landing/), /storybits er innloggingen
 * (login.html). Denne SPA-en nås bare via fallbacken for ukjente adresser, og sender dem videre til innloggingen
 * med en full sideinnlasting — så den gamle katalogen og innloggingsdialogen aldri vises. /titles/* håndteres av
 * Netlify-proxyen og når aldri hit.
 */
export default function App() {
  useEffect(() => {
    window.location.replace('/storybits');
  }, []);
  return null;
}
